import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Retorna os cadastros individuais
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_cns - CNS do profissional
 */
export async function getCadastrosIndividuais(cod_ibge, nu_cns) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/exames-hiv-sifilis/detalhado/' + cod_ibge + '/' + nu_cns
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - Micro área do profissional
 */
export async function getCadastrosIndividuaisPorMicroArea(
  cod_ibge,
  nu_ine,
  micro_area
) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/exames-hiv-sifilis/detalhado/microarea/' +
        cod_ibge +
        '/' +
        nu_ine +
        '/' +
        micro_area
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem ACS de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisSemAcs(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/exames-hiv-sifilis/detalhado/sem-acs/' + cod_ibge + '/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais sem equipe
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getCadastrosIndividuaisSemEquipe(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/exames-hiv-sifilis/detalhado/sem-equipe/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros individuais todos de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosIndividuaisTodosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/exames-hiv-sifilis/detalhado/todos/equipe/' +
        cod_ibge +
        '/' +
        nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor de acordo com o valor
/**
 *
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'blue'
  } else {
    return 'red'
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(
  dt_ultimo_teste_sifilis,
  dt_ultima_sorologia_sifilis,
  dt_ultimo_teste_hiv,
  dt_ultima_sorologia_hiv
) {
  if (
    (dt_ultimo_teste_sifilis != null || dt_ultima_sorologia_sifilis != null) &&
    (dt_ultimo_teste_hiv != null || dt_ultima_sorologia_hiv != null)
  ) {
    return 'green'
  } else {
    return 'red'
  }
}

export function comparaQuadrimestre(dpp) {
  if (dpp != null) {
    let quadrimestre_atual = ''
    let data_atual = new Date()
    let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
    let ano_atual = parseInt(data_atual.getFullYear())
    if (mes_atual >= 1 && mes_atual <= 4) {
      quadrimestre_atual = ano_atual + ' Q1'
    } else if (mes_atual >= 5 && mes_atual <= 8) {
      quadrimestre_atual = ano_atual + ' Q2'
    } else if (mes_atual >= 9 && mes_atual <= 12) {
      quadrimestre_atual = ano_atual + ' Q3'
    } else {
      quadrimestre_atual = ''
    }

    let quadrimestre_dpp = ''
    let data_dpp_split = dpp.split('-')
    let mes_dpp = data_dpp_split[1]
    let ano_dpp = data_dpp_split[0]
    if (mes_dpp >= 1 && mes_dpp <= 4) {
      quadrimestre_dpp = ano_dpp + ' Q1'
    } else if (mes_dpp >= 5 && mes_dpp <= 8) {
      quadrimestre_dpp = ano_dpp + ' Q2'
    } else if (mes_dpp >= 9 && mes_dpp <= 12) {
      quadrimestre_dpp = ano_dpp + ' Q3'
    } else {
      quadrimestre_dpp = ''
    }

    if (quadrimestre_atual == quadrimestre_dpp) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function exibirVermelhos(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      (item.dt_ultimo_teste_sifilis != null ||
        item.dt_ultima_sorologia_sifilis != null) &&
      (item.dt_ultimo_teste_hiv != null || item.dt_ultima_sorologia_hiv != null)
    ) {
      return false
    } else {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  let filtro = cadastros.filter((item) => {
    if (
      (item.dt_ultimo_teste_sifilis != null ||
        item.dt_ultima_sorologia_sifilis != null) &&
      (item.dt_ultimo_teste_hiv != null || item.dt_ultima_sorologia_hiv != null)
    ) {
      return true
    } else {
      return false
    }
  })
  return filtro
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional
) {
  let title_pdf = 'Exames HIV e Sífilis'
  let titlePdfSave = utils.methods.titlePdf(
    'Exames HIV e Sífilis',
    selectEquipe.no_equipe
  )

  let description_pdf = 'Exames para detecção de Sífilis e HIV em gestantes'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'TESTE HIV',
    'SOROLOGIA HIV',
    'TESTE SÍFILIS',
    'SOROLOGIA SÍFILIS',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.dt_ultimo_teste_hiv = utils.methods.formatDate(
      cadastros[i].dt_ultimo_teste_hiv
    )
    obj.dt_ultima_sorologia_hiv = utils.methods.formatDate(
      cadastros[i].dt_ultima_sorologia_hiv
    )
    obj.dt_ultimo_teste_sifilis = utils.methods.formatDate(
      cadastros[i].dt_ultimo_teste_sifilis
    )
    obj.dt_ultima_sorologia_sifilis = utils.methods.formatDate(
      cadastros[i].dt_ultima_sorologia_sifilis
    )
    let documentoText = ''
    let lineBreak = ''
    if (cadastros[i].nu_cpf !== null && cadastros[i].nu_cpf !== undefined) {
      lineBreak = '\n'
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns !== null && cadastros[i].nu_cns !== undefined) {
      documentoText += `${lineBreak}CNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )
      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let dt_ultimo_teste_sifilis = data.row.raw[6]
          let dt_ultima_sorologia_sifilis = data.row.raw[7]
          let dt_ultimo_teste_hiv = data.row.raw[4]
          let dt_ultima_sorologia_hiv = data.row.raw[5]
          if (
            (dt_ultimo_teste_sifilis != null ||
              dt_ultima_sorologia_sifilis != null) &&
            (dt_ultimo_teste_hiv != null || dt_ultima_sorologia_hiv != null)
          ) {
            doc.setTextColor(2, 99, 57) // verde
          } else {
            doc.setTextColor(194, 10, 16) // vermelho
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export async function carregarSerieHistoricaPorEquipe(cod_ibge, nu_ine, xaxis) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/equipe/' + cod_ibge + '/' + nu_ine + '/2'
    )
    let array_chart_equipe = []
    for (let i = 0; i < xaxis.length; i++) {
      var eixo_x_atual = xaxis[i]
      for (const item of response.data) {
        var resultado = 0
        if (item.mes_ano == eixo_x_atual) {
          resultado = item.resultado
          break
        } else {
          resultado = null
        }
      }
      array_chart_equipe.push(resultado)
    }
    return array_chart_equipe
  } catch (err) {
    console.log(err)
  }
}

export function resultadoEquipe(valor, estimadas, informadas) {
  let denominador = 0
  if (parseInt(informadas) >= parseInt(estimadas)) {
    denominador = parseInt(informadas)
  } else {
    denominador = parseInt(estimadas)
  }
  let resultado = (valor / denominador) * 100
  if (Number.isNaN(resultado)) {
    return ''
  }
  return resultado.toFixed(0)
}

export async function carregarSerieHistoricaPorAcs(
  cod_ibge,
  profissional,
  xaxis
) {
  try {
    let response = await Vue.prototype.$api.get(
      '/app/serie-historica/acs/' + cod_ibge + '/' + profissional + '/2'
    )

    let array_chart_acs = []
    if (response.data.length !== 0) {
      for (let i = 0; i < xaxis.length; i++) {
        var eixo_x_atual = xaxis[i]
        for (const item of response.data) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = item.resultado
            break
          } else {
            resultado = null
          }
        }
        array_chart_acs.push(resultado)
      }
      return array_chart_acs
    } else {
      return null
    }
  } catch (err) {
    console.log(err)
  }
}
